/**
 * A vendor order whose items are "on order" until someone marks them received.
 * Nothing here is stock: pending lines live only in `purchase_order_items` and
 * only become `serialized_units` / `stock_levels` when received.
 *
 * `closed` = some of it arrived and the rest is no longer expected.
 * `cancelled` = nothing arrived.
 */
export const PURCHASE_ORDER_STATUSES = [
    'ordered',
    'partially_received',
    'received',
    'closed',
    'cancelled',
];
/** Still waiting on goods. */
export const OPEN_PURCHASE_ORDER_STATUSES = [
    'ordered',
    'partially_received',
];
export const TERMINAL_PURCHASE_ORDER_STATUSES = [
    'received',
    'closed',
    'cancelled',
];
//# sourceMappingURL=purchase-order-states.js.map